import { Sprite, Texture } from 'pixi.js';
import { CircleShapeDescriptor } from '../../../../elements/resource/types/shape.type';
import { GlowElement } from '../primitive/glow-element';
import { RectangleController } from '../../../../elements/util/rectangle-controller/rectangle-controller';
import { PrimitiveShape } from '../primitive/primitive-shape';
import { SVG } from '../primitive/svg-element';

export interface GlowShapeDescriptor extends CircleShapeDescriptor {
  alpha: number;
}

export class GlowShape extends PrimitiveShape<
  GlowElement,
  GlowShapeDescriptor
> {
  get radius() {
    return this.descriptor.rx;
  }

  getType() {
    return 'glow-shape';
  }

  set radius(val: number) {
    this.descriptor.rx = val;
  }

  constructor(cs, data, config) {
    super(cs, data, config);
    this.init();
  }

  _hide() {}

  init() {
    super.init();
    // console.log('------ init-glow-shape ---------'); //
    // this.element = this.createGlowCircle({
    //   x: this.x,
    //   y: this.y,
    //   radius: this.descriptor.rx,
    //   color: this.descriptor.svgAttributes.fill.color,
    //   alpha: 0.7,
    // });

    this.element = new GlowElement(this, this.container, {
      x: this.radius * 1.5,
      y: this.radius * 1.5,
      alpha: 0.5,
      fill: this.descriptor.svgAttributes.fill.color,
      radius: this.descriptor.rx,
    })
      .mouseover(() => {
        this.select({
          onHover: true,
        });
      })
      .mouseout(() => {
        this.deselect({
          onHover: true,
        });
      });

    this.element
      .drag(
        (dx, dy) => {
          this.drag(dx, dy);
        },
        () => this.startBaseDrag(),
        () => {
          this.endDrag();
        },
      )
      .click(() => {
        // console.log('ps.element > clicked');
        this.clicked();
      });
    this.initRC();
    this.redraw();
  }

  initRC() {
    console.log('glow-shape-initRC', this.x, this.y);

    const width = this.radius * 3;
    this.rc = new RectangleController(
      this,
      {
        // offset: [this.x - width / 2, this.y - width / 2],
        width,
        height: width,
        startDrag: () => {
          this._x = this.x;
          this._y = this.y;
          console.log('rc-startDrag');
        },
        drag: resp => {
          console.log('dragRes', resp);
          const { dx, dy, width, height } = resp;

          this.x = this._x + dx;
          this.y = this._y + dy;

          if (width >= height) {
            this.radius = width / 3;
            this._scale = {
              x: 1,
              y: height / width,
            };
          } else {
            this.radius = height / 3;
            this._scale = {
              x: width / height,
              y: 1,
            };
          }
          this.refreshElement();
          this.redraw();
        },
        endDrag: () => {},
      },
      this.circleContainer,
      this.auxCircleContainer,
      // this.container,
    );
  }

  refreshElement(): void {
    this.element.patch({
      x: this.radius * 1.5,
      y: this.radius * 1.5,
      alpha: 0.5,
      fill: this.svgAttributes.fill.color,
      radius: this.descriptor.rx,
    });
  }

  applyScale(scale) {
    if (!scale) {
      return;
    }
    this.container.scale = scale;
  }
  afterInit(): void {
    this.element.element.mask = this.cs.previewShape.maskRect.element;
  }

  createGlowCircle({ x, y, radius, color, alpha }) {
    const canvas = document.createElement('canvas');
    const size = radius * 2;
    canvas.height = size * 2;
    canvas.width = size * 2;

    const ctx = canvas.getContext('2d');
    const gradient = ctx.createRadialGradient(size, size, 0, size, size, size);
    gradient.addColorStop(0, `rgba(${this.hexToRgb(color)},${alpha})`);
    gradient.addColorStop(1, `rgba(${this.hexToRgb(color)},0)`);

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const texture = Texture.from(canvas);
    const sprite = new Sprite(texture);
    sprite.anchor.set(0.5);
    sprite.position.set(x, y);
    return sprite;
  }

  hexToRgb(hex) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Parse shorthand (e.g. #03F) to full form (e.g. #0033FF)
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `${r}, ${g}, ${b}`;
  }
}
